var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCandle3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.702,
    height: 65.128,
    viewBox: "0 0 71.702 65.128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "candle-3",
    transform: "translate(0 -23.473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224",
    transform: "translate(0 50.347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M70.863,229.883a5.342,5.342,0,0,0-7.075-1.8l-2.608,1.442a20.168,20.168,0,0,0,2.087-8.946,1.279,1.279,0,0,0-1.279-1.279H44.353v-2.656a1.279,1.279,0,0,0-2.557,0V219.3s-18.737-.012-19.113-.019a11.246,11.246,0,0,0-9.6,5.206,24.828,24.828,0,0,1-7.859,7.726L.609,235.055a1.279,1.279,0,0,0,1.34,2.178l4.616-2.841a27.4,27.4,0,0,0,8.674-8.526,8.688,8.688,0,0,1,7.248-4.028h.149a11.9,11.9,0,0,1,2.113.229L40.875,225.3a2.2,2.2,0,0,1,1.651,2.875,2.2,2.2,0,0,1-2.437,1.459l-8.459-1.375A4.428,4.428,0,0,0,30.18,237l14.94,2.531a7.254,7.254,0,0,0,4.7-.8l15.2-8.405a2.775,2.775,0,0,1,2.825,4.774L48.2,247.513a8.441,8.441,0,0,1-5.769,1.21l-23.2-3.506a6.166,6.166,0,0,0-4.315.946l-7.77,5.11a1.279,1.279,0,1,0,1.405,2.137l7.77-5.11a3.612,3.612,0,0,1,2.528-.554l23.2,3.506a11,11,0,0,0,7.517-1.577l19.647-12.416a5.333,5.333,0,0,0,1.647-7.376Zm-14.535,2.326-7.743,4.281a4.688,4.688,0,0,1-3.039.517l-14.939-2.531a1.879,1.879,0,0,1-1.55-2.013,1.87,1.87,0,0,1,2.162-1.677l8.459,1.375a4.76,4.76,0,0,0,1.7-9.366l-4.666-.935H60.664A17.584,17.584,0,0,1,56.329,232.209Z",
    transform: "translate(0 -215.367)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226",
    transform: "translate(32.279 23.473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M246.476,28.384a30.039,30.039,0,0,0-6.351-4.763,1.279,1.279,0,0,0-1.876,1.131c0,5.558-2.071,7.5-4.074,9.37-1.852,1.733-3.768,3.526-3.677,7.538.082,3.62,2.3,6.465,6.087,7.8a2.255,2.255,0,0,0,2.739-3.178,4.981,4.981,0,0,1,.742-6.272,10.079,10.079,0,0,0,2.021,3.2c.848,1,1.328,1.617,1.328,2.55a6.652,6.652,0,0,1-.056.89,2.255,2.255,0,0,0,3.2,2.335,9.188,9.188,0,0,0,5.431-7.38C252.535,37.048,250.627,32.474,246.476,28.384Zm2.978,12.925a6.56,6.56,0,0,1-3.5,5.121c.015-.216.022-.438.022-.664a6.263,6.263,0,0,0-1.932-4.2,6.1,6.1,0,0,1-1.859-3.958,1.279,1.279,0,0,0-1.992-1c-3.9,2.633-5.143,6.3-3.47,10.158a5.638,5.638,0,0,1-3.665-5.165c-.065-2.869,1.165-4.02,2.867-5.613a12.834,12.834,0,0,0,4.773-9.017C243.9,29.134,250.279,34.362,249.454,41.309Z",
    transform: "translate(-230.496 -23.473)",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandle3);
export default __webpack_public_path__ + "static/media/candle-3.eb2097e85ab028f25ac6166c68d7f148.svg";
export { ForwardRef as ReactComponent };